import React from 'react'
import styles from './Carousel.module.css'
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Shared from '../services/Shared';

const IMAGES = [
    {
        alt: 'Football',
        caption: 'Touchdown Canine U!',
        src: Shared.assets + '/football_1.png',
    },
    {
        alt: 'Football',
        caption: 'Playing defensive',
        src: Shared.assets + '/football_2.png',
    },
    {
        alt: 'Football',
        caption: 'Little league!',
        src: Shared.assets + '/football_3.png',
    },
    {
        alt: 'Football',
        caption: 'GO TAIL WAGGERS!',
        src: Shared.assets + '/football_4.png',
    },
    {
        alt: 'Football',
        caption: 'Our team mascot!',
        src: Shared.assets + '/football_5.png',
    },
    {
        alt: 'Football',
        caption: 'Great play by our star quarterback!',
        src: Shared.assets + '/football_6.png',
    }
]

export default function Carousel(props) {

    const [index, setIndex] = React.useState(0);
    const image = IMAGES[index];

    function onLeft(e) {
        let i = index;
        setIndex(--i < 0 ? IMAGES.length - 1 : i);
    }

    function onRight(e) {
        let i = index;
        setIndex(++i >= IMAGES.length ? 0 : i);
    }

    return (
        <div>
            <div className={styles.controls}>
                <div className={styles.arrow}><ArrowBack fontSize="large" onClick={onLeft} /></div>
                <div className={styles.imgDiv}>
                    <div><img className={styles.img} alt={image.alt} src={image.src} /></div>
                    <div className={styles.caption}>{image.caption}</div>
                </div>
                <div className={styles.arrow}><ArrowForward fontSize="large" onClick={onRight} /></div>
            </div>
        </div>
    )
}
